import Seo from '../components/Seo';
import HeaderSection from './HeaderSection';
import HeroSection from './HeroSection';
import HowIsRide from './HowIsRide';
import FeaturesSection from './FeaturesSection';
import ForThePeople from "./ForThePeople";
import HowItWorks from "./HowItWorks";
import Testimonials from "./Testimonials";
import AppPreview from "./AppPreview";
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import LaunchOfferModal from './LaunchOfferModal';

const Home = () => {
  return (
    <>
      <Seo
        title="TotoWala - Best Ride Booking Service in India | Toto, Bike, Cab & Auto"
        description="TotoWala offers the best ride booking service across India including tier-3 and tier-4 cities. Book Toto, Bike, Cab & Auto rides instantly. Safe, reliable & affordable transportation available 24/7."
        canonical="/"
        schemaMarkup={{
          '@context': 'https://schema.org',
          '@graph': [
            {
              '@type': 'WebSite',
              '@id': 'https://totowala.in/#website',
              url: 'https://totowala.in/',
              name: 'TotoWala',
              description: 'India\'s #1 ride-booking app - zero commission, no hidden fees, near-zero surge pricing.',
              publisher: { '@id': 'https://totowala.in/#organization' },
            },
            {
              '@type': 'MobileApplication',
              name: 'TotoWala',
              description: 'Book Toto, Bike, Cab & Auto rides instantly across India.',
              url: 'https://totowala.in/',
              applicationCategory: 'TransportationApplication',
              operatingSystem: 'Android',
              offers: { '@type': 'Offer', price: '0', priceCurrency: 'INR' },
              aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.8', reviewCount: '1200' },
            },
            {
              '@type': 'Organization',
              '@id': 'https://totowala.in/#organization',
              name: 'TotoWala Technologies Private Limited',
              url: 'https://totowala.in',
              logo: 'https://totowala.in/images/logo.png',
              sameAs: [
                'https://www.facebook.com/totowalaindia',
                'https://www.instagram.com/totowalaindia/',
                'https://x.com/totowalaindia',
                'https://linkedin.com/company/totowala',
                'https://play.google.com/store/apps/details?id=com.elt.totowala',
                'https://play.google.com/store/apps/details?id=com.elt.totowalafordrivers',
              ],
              foundingLocation: { '@type': 'Place', name: 'Bhagalpur, Bihar, India' },
              address: {
                '@type': 'PostalAddress',
                addressLocality: 'Bhagalpur',
                addressRegion: 'Bihar',
                postalCode: '812003',
                addressCountry: 'IN',
              },
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'customer support',
                telephone: '+91-8088257606',
                email: 'contact@totowala.in',
                areaServed: 'IN',
                availableLanguage: ['en', 'hi'],
              },
              member: [
                { '@id': 'https://totowala.in/our-team#namit-rai' },
                { '@id': 'https://totowala.in/our-team#tushar-anand' },
              ],
            },
            {
              '@type': 'Person',
              '@id': 'https://totowala.in/our-team#namit-rai',
              name: 'Namit Rai',
              jobTitle: 'Founder',
              description: 'Namit Rai is the Founder of TotoWala Technologies, leading India\'s driver-first ride-booking platform from Bhagalpur.',
              worksFor: { '@id': 'https://totowala.in/#organization' },
              url: 'https://totowala.in/our-team',
              sameAs: ['https://www.linkedin.com/in/namitrai/'],
            },
            {
              '@type': 'Person',
              '@id': 'https://totowala.in/our-team#tushar-anand',
              name: 'Tushar Anand',
              jobTitle: 'Co-Founder & CTO',
              description: 'Tushar Anand is Co-Founder and CTO at TotoWala Technologies, responsible for all technical decisions and the mobile and backend platform powering rides across India.',
              worksFor: { '@id': 'https://totowala.in/#organization' },
              url: 'https://totowala.in/our-team',
              sameAs: ['https://www.linkedin.com/in/tusharanand2000/'],
            }
          ],
        }}
      />
      {/* Header outside overflow container so sticky positioning works correctly */}
      <HeaderSection />

      <div style={{ overflowX: 'clip' }}>
        <HeroSection />
        <FeaturesSection />
        <HowIsRide />
        <ForThePeople />
        <HowItWorks />
        <AppPreview />
        <Testimonials />
        <Footer />
      </div>
      <ScrollToTop />
      <LaunchOfferModal />
    </>
  );
};

export default Home;
